import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird, viTrashCan, viWebhooks } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function WebhookItem({ webhook, dispatch, ...props }) {
  const [pending, setPending] = useState(false);

  const handleRemoveWebbhook = () => {
    setPending(true);

    Promise.resolve(Api.deleteWebhookInboundRoute(webhook, props.inbound))
      .then(() => dispatch({ type: "removeWebhook", webhook }))
      .finally(() => setPending(false));
  };

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          secondaryAction={
            <IconButton
              color="inherit"
              onClick={() => handleRemoveWebbhook()}
              aria-label="Delete this webhook"
              disabled={pending}
            >
              <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
            </IconButton>
          }
        >
          <ListItemAvatar>
            <Avatar text={webhook.name} icon={viWebhooks} px={32} />
          </ListItemAvatar>
          <ListItemText primary={webhook.name} />
        </ListItem>
      </List>
    </Card>
  );
}

WebhookItem.propTypes = {
  inbound: PropTypes.object,
  webhook: PropTypes.object,
  dispatch: PropTypes.func,
};

export default WebhookItem;
